<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Add {{feeTypeName}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div class="mb-3">
    <label class="form-label fw-semibold">Item</label>
    <select class="form-select" [(ngModel)]="selectedItem" (ngModelChange)="feeChange()">
      <option [ngValue]="null">Select Fee</option>
      <option *ngFor="let f of fees" [ngValue]="f">{{f.description}}</option>
    </select>
  </div>

  <form [formGroup]="newInvoiceItemDetails" autocomplete="off">

    <div class="mb-3">
      <label class="form-label fw-semibold">Description (as it appears on invoice)</label>
      <textarea class="form-control" formControlName="description" rows="3"></textarea>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">Net</label>
      <div class="input-group">
        <span class="input-group-text">£</span>
        <input class="form-control" formControlName="net" type="number">
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold me-2">Add VAT</label>
      <input type="checkbox" class="form-check-input" formControlName="addVat">
    </div>

  </form>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success"
    [disabled]="newInvoiceItemDetails.invalid"
    (click)="addInvoiceItem()">Add</button>
</div>